import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

import type { SelectChangeEvent } from "@mui/material";

interface Props {
  quotingUnitOfMeasure: UnitOfMeasureType;
  setQuotingUnitOfMeasure: (newValue: UnitOfMeasureType) => void;
}

const UNIT_OF_MEASURE_OPTIONS: { value: UnitOfMeasureType; label: string }[] = [
  { value: "ALL_IN", label: "All-in price" },
  { value: "PER_METRIC_TON", label: "Price per metric ton" },
  { value: "PER_SHORT_TON", label: "Price per short ton" },
  { value: "PER_HOUR", label: "Price per hour" },
];

export function PricingUnitOfMeasureMenu(props: Props) {
  const { quotingUnitOfMeasure, setQuotingUnitOfMeasure } = props;

  const handleChange = (event: SelectChangeEvent) => {
    setQuotingUnitOfMeasure(event.target.value as UnitOfMeasureType);
  };

  return (
    <FormControl fullWidth>
      <InputLabel id="pricing-unit-of-measure-label">Pricing Method</InputLabel>
      <Select
        labelId="pricing-unit-of-measure-label"
        id="pricing-unit-of-measure-select"
        value={quotingUnitOfMeasure}
        label="Pricing Method"
        onChange={handleChange}
      >
        {UNIT_OF_MEASURE_OPTIONS.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
